var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    [
      _c(
        "v-card",
        {
          staticClass: "conteneurLead",
          staticStyle: { width: "100%" },
          attrs: { flat: "", id: "conteneurLead" }
        },
        [
          _c(
            "v-card-title",
            {
              staticClass: "primary white--text",
              staticStyle: { height: "52px", padding: "0px" }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.cancelDialog()
                    }
                  }
                },
                [
                  _c("v-icon", { staticClass: "white--text" }, [
                    _vm._v("close")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "title tf_title_dialog" }, [
                _vm._v(
                  _vm._s(_vm._f("cap")(_vm.$t("edit"))) +
                    " " +
                    _vm._s(_vm.$tc("Intention", 1)) +
                    " : " +
                    _vm._s(_vm.intentDialog.code)
                )
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _vm.$vuetify.breakpoint.smAndDown
                ? _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: {
                        flat: "",
                        color: "primary",
                        loading: _vm.loading,
                        disabled: _vm.loading
                      },
                      on: { click: _vm.submitDialogUpdateIntent }
                    },
                    [_vm._v(_vm._s(_vm.$t("submit")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tabs",
            {
              attrs: { left: "", "slider-color": "secondary" },
              model: {
                value: _vm.currentTab,
                callback: function($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab"
              }
            },
            [
              _vm._l(_vm.tabs, function(tab) {
                return _c(
                  "v-tab",
                  { key: tab.index },
                  [
                    _c("v-icon", { staticClass: "primary--text" }, [
                      _vm._v(_vm._s(tab.icone))
                    ]),
                    _vm._v("\n        " + _vm._s(tab.name) + "\n        ")
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "v-tab-item",
                { key: "tab_fiche" },
                [
                  _c(
                    "v-card-text",
                    {
                      style: !_vm.$vuetify.breakpoint.smAndDown
                        ? "height: calc(100vh - 300px);"
                        : ""
                    },
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md4: "", "pr-2": "" } },
                            [
                              _c(
                                "v-card-text",
                                [
                                  _vm.modeExpert
                                    ? _c("p", [
                                        _c(
                                          "span",
                                          { staticClass: "body-1 font-italic" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("intentCode")) +
                                                " :"
                                            )
                                          ]
                                        ),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "body-2 font-weight-bold"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.intentDialog.code)
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.modeExpert
                                    ? _c("p", [
                                        _c(
                                          "span",
                                          { staticClass: "body-1 font-italic" },
                                          [_vm._v("chatbot ID :")]
                                        ),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "body-2 font-weight-bold"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.intentDialog.botWorkspace
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("v-textarea", {
                                    attrs: {
                                      label: "Thème / Description",
                                      error: _vm.wzErrors.has("intentDialog"),
                                      errors: _vm.wzErrors.collect(
                                        "intentDialog"
                                      )
                                    },
                                    model: {
                                      value: _vm.intentDialog.desc,
                                      callback: function($$v) {
                                        _vm.$set(_vm.intentDialog, "desc", $$v)
                                      },
                                      expression: "intentDialog.desc"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v("*" + _vm._s(_vm.$t("required")))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md8: "", "pl-2": "" } },
                            [
                              _c(
                                "v-layout",
                                [
                                  _c("v-flex", { attrs: { xs6: "" } }, [
                                    _c(
                                      "span",
                                      { attrs: { "align-left": "" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("intentExamples") + "*")
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-xs-right",
                                      attrs: { xs6: "" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "btnIntentBot",
                                          on: {
                                            click: function($event) {
                                              return _vm.addExample()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                small: "",
                                                icon: "",
                                                color: "secondary"
                                              }
                                            },
                                            [_c("v-icon", [_vm._v("add")])],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "pl-2" }, [
                                            _vm._v("Ajouter un nouvel exemple")
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    overflow: "auto",
                                    height: "calc(100vh - 350px)"
                                  }
                                },
                                [
                                  _c("v-data-table", {
                                    attrs: {
                                      items: _vm.samplesInt,
                                      "hide-actions": ""
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "items",
                                        fn: function(props) {
                                          return [
                                            _c(
                                              "td",
                                              [
                                                _c(
                                                  "v-edit-dialog",
                                                  {
                                                    attrs: {
                                                      "cancel-text": _vm.$t(
                                                        "cancel"
                                                      ),
                                                      "save-text": _vm.$t(
                                                        "submit"
                                                      ),
                                                      "return-value":
                                                        _vm.samplesInt,
                                                      large: "",
                                                      lazy: ""
                                                    },
                                                    on: {
                                                      "update:returnValue": function(
                                                        $event
                                                      ) {
                                                        _vm.samplesInt = $event
                                                      },
                                                      "update:return-value": function(
                                                        $event
                                                      ) {
                                                        _vm.samplesInt = $event
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("div", [
                                                      _c("code", [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item.content
                                                          )
                                                        )
                                                      ])
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mt-3 title",
                                                        attrs: {
                                                          slot: "input"
                                                        },
                                                        slot: "input"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "editContent"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        slot: "input",
                                                        label: "Modification",
                                                        "single-line": "",
                                                        counter: "",
                                                        autofocus: ""
                                                      },
                                                      slot: "input",
                                                      model: {
                                                        value:
                                                          props.item.content,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            props.item,
                                                            "content",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "props.item.content"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-right" },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      icon: "",
                                                      flat: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.deleteSampleIntent(
                                                          props.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("delete")
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.cancelDialog()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    loading: _vm.loading,
                    disabled: _vm.loading
                  },
                  on: { click: _vm.submitDialogUpdateIntent }
                },
                [_vm._v(_vm._s(_vm.$t("submit")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "390" },
          model: {
            value: _vm.showDialogAddQuestionIntent,
            callback: function($$v) {
              _vm.showDialogAddQuestionIntent = $$v
            },
            expression: "showDialogAddQuestionIntent"
          }
        },
        [
          _c("wz-new-question-intent", {
            attrs: {
              intentDialog: _vm.intentDialog,
              modeExpert: _vm.modeExpert,
              botWorkspace: _vm.botWorkspace
            },
            on: {
              closeDialog: _vm.closeDialogNewQuestionIntent,
              addNewEx: _vm.addNewEx
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef2b4c0e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef2b4c0e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzUpdateIntent.vue
// module id = null
// module chunks = 